import React, { useState, useEffect, useRef } from "react";
import "./index.less";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Button, Input, Anchor, message, Popover, Collapse, Carousel, Dropdown, Statistic, Modal } from "antd";
import { DotLoader } from 'react-spinners';
import CountUp from 'react-countup';
import {
  QuestionCircleOutlined,
  PlusOutlined
} from "@ant-design/icons";
import "animate.css";
import WOW from "wow.js";
import nodata from "@/assets/images/nodata.png";
import xingxing from "@/assets/images/xingxing.png";
import line1 from "@/assets/images/line1.png";
import line2 from "@/assets/images/line2.png";
import fangkuai from "@/assets/images/fangkuai.png";
import xing2 from "@/assets/images/xing2.png";
import vip from "@/assets/images/vip.png";
import bg4 from "@/assets/images/bg4.png";
import duojiantou from "@/assets/images/duojiantou.png";
import { useAppKitAccount, useAppKit, useAppKitNetwork, useWalletInfo } from "@reown/appkit/react";
import { base, sepolia } from '@reown/appkit/networks'
import { tokenAbi, LOCKLPABI, RWAABI } from "@/web3/ido.js";
import { useAccount, useSignMessage, useDisconnect, useReadContract, useBalance, useWriteContract, useWaitForTransactionReceipt, useSwitchChain, useBlockNumber, useSendTransaction, useGasPrice } from 'wagmi'
import { parseEther, parseUnits, parseGwei, formatEther } from 'viem';
import { useQueryClient } from '@tanstack/react-query'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import axios from "axios";
import dayjs from "dayjs";
const { Link } = Anchor;
const Mine = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { invite } = useParams();
  const [tabIndex, setTabIndex] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [isSignMessage, setIsSignMessage] = useState(false);
  const [loadingInvite, setLoadingInvite] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const { data: signature, isLoading, signMessage } = useSignMessage()
  const [vipText, setVipText] = useState([
    t("member"),
    t("Operators"),
    t("Operations Center"),
    t("Partner"),
    t("Genesis Partner")
  ]);
  const RWA_CONTRACT_ADDRESS = import.meta.env.VITE_RWA_CONTRACT_ADDRESS;
  const UDSC_APPROVE_CONTRACT_ADDRESS = import.meta.env.VITE_UDSC_APPROVE_CONTRACT_ADDRESS;
  const TOKEN_ADDRESS = import.meta.env.VITE_TOKEN_ADDRESS;
  const chainIdOwn = Number(import.meta.env.VITE_CHAIN_ID_RWA)
  const USDC_DECIMAL = Number(import.meta.env.VITE_USDC_DECIMAL)
  const { open, close } = useAppKit()
  const { caipNetwork, caipNetworkId, chainId, switchNetwork } = useAppKitNetwork()
  const { address, isConnected, caipAddress, status } = useAppKitAccount()
  const queryClient = useQueryClient()
  const { data: blockNumber } = useBlockNumber({ watch: true })
  const { writeContract, error, data: writeData, success } = useWriteContract();
  const isApprovedString = useRef(0);
  const [inviterAddress, setInviterAddress] = useState("")
  const [inviter, setInviter] = useState("")
  const [dataListshifang, setDataListshifang] = useState([])
  const [dataListzhitui, setDataListzhitui] = useState([])
  const [dataListzhituijiangli, setDataListzhituiliangji] = useState([])
  const [dataListyeji, setDataListyeji] = useState([])
  const [dataListtouzi, setDataListtouzi] = useState([])
  const [dataListlingqu, setDataListlingqu] = useState([])
  const [remainingAmount, setRemainingAmount] = useState(0)
  const [transferAmount, settransferAmount] = useState(0)
  const NODE_ENV = import.meta.env.VITE_NODE_ENV;

  const result = useWaitForTransactionReceipt({
    hash: writeData,
    chainId: chainIdOwn,
    confirmations: 1,
  })
  const { data: homeView, queryKey: queryKey } = useReadContract({
    address: RWA_CONTRACT_ADDRESS,
    abi: RWAABI,
    functionName: 'homeView',
    chainId: chainIdOwn,
    args: [address]
  })
  const { data: rwaInfo, queryKey: queryKey1 } = useReadContract({
    address: RWA_CONTRACT_ADDRESS,
    abi: RWAABI,
    functionName: 'info',
    chainId: chainIdOwn,
  })
  const { data: remainingData, queryKey: queryKey2 } = useReadContract({
    address: RWA_CONTRACT_ADDRESS,
    abi: RWAABI,
    functionName: 'remaining',
    chainId: chainIdOwn,
    args: [address]
  })
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (chainId) {
        if (chainId != Number(chainIdOwn)) {
          switchNetwork(NODE_ENV === "dev" ? sepolia : base)

        }
      }
    }, 300);
    return () => clearTimeout(timeout);
  }, [chainId]);
  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: queryKey })
    queryClient.invalidateQueries({ queryKey: queryKey1 })
    queryClient.invalidateQueries({ queryKey: queryKey2 })

  }, [blockNumber, queryClient])
  useEffect(() => {
    if (address) {

      let _address = window.sessionStorage.getItem("approveAddress");
      if (_address === address) {
        getList()
        setIsSignMessage(true)
      } else {
        signMessageHandle()
      }

    }
  }, [address])
  useEffect(() => {
    console.log("new")
    console.log("homeView", homeView)
    if (Number(homeView?.steak) > 0) {
      setInviterAddress(window.location.origin + "/rwamine/" + address)
    } else {
      setInviterAddress("")
    }
    if (homeView?.higherLevel != "0x0000000000000000000000000000000000000000") {
      setInviter(homeView?.higherLevel)
    } else {
      if (invite) {
        setInviter(invite)
      }
    }
  }, [homeView])
  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (error) {
        setLoading(false)
        setLoading1(false)
        setLoadingInvite(false)
        let str = JSON.parse(JSON.stringify(error).replace(/\n/g, ""));
        message.warning(str.shortMessage);

      }

    }, 300);
    return () => clearTimeout(timeout);
  }, [error]);
  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (signature) {
        console.log("signature", signature)
        window.sessionStorage.setItem("approveAddress", address);
        setIsSignMessage(true)
        getList();
      }

    }, 300);
    return () => clearTimeout(timeout);
  }, [signature]);
  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (result?.status === "success") {
        message.success(t("Success"))
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
      if (result?.status === "error") {
        message.error(t("error"));
        setLoadingInvite(false)
        setLoading(false)
        setLoading1(false)

      }
    }, 300);
    return () => clearTimeout(timeout);
  }, [result]);
  const getList = async () => {
    // 释放
    try {
      const res = await axios.get(`https://laychat.aitechprod.xyz/api/index/get_release?address=${address}&page=1&pagesize=99999&type=2`);
      if (res.data.code === 1) {
        setDataListshifang(res.data.data.data)
      }
      // setResponse(res.data);
    } catch (error) {
      console.error('请求失败:', error);
    }
    // 投资
    try {
      const res = await axios.get(`https://laychat.aitechprod.xyz/api/index/get_stake_amount?address=${address}&page=1&pagesize=99999&type=2`);
      if (res.data.code === 1) {
        setDataListtouzi(res.data.data.data)
      }
      // setResponse(res.data);
    } catch (error) {
      console.error('请求失败:', error);
    }
    // 业绩
    try {
      const res = await axios.get(`https://laychat.aitechprod.xyz/api/index/get_performance?address=${address}&page=1&pagesize=99999&type=2`);
      if (res.data.code === 1) {
        setDataListyeji(res.data.data.data)
      }
      // setResponse(res.data);
    } catch (error) {
      console.error('请求失败:', error);
    }
    // 直推
    try {
      const res = await axios.get(`https://laychat.aitechprod.xyz/api/index/get_invite?address=${address}&page=1&pagesize=99999&type=2`);
      if (res.data.code === 1) {
        setDataListzhitui(res.data.data.data)
      }
      // setResponse(res.data);
    } catch (error) {
      console.error('请求失败:', error);
    }
    // 领取
    try {
      const res = await axios.get(`https://laychat.aitechprod.xyz/api/index/get_claim_log?address=${address}&page=1&pagesize=99999&type=2`);
      if (res.data.code === 1) {
        setDataListlingqu(res.data.data.data)
      }
      // setResponse(res.data);
    } catch (error) {
      console.error('请求失败:', error);
    }
    // https://deai.layergpt.io
    try {
      const res = await axios.get(`https://laychat.aitechprod.xyz/api/index/get_address_reward?address=${address}`);
      if (res.data.code === 1) {
        setRemainingAmount(res.data.data.remaining_amount)
        settransferAmount(res.data.data.transfer_amount)

      }
      // setResponse(res.data);
    } catch (error) {
      console.error('请求失败:', error);
    }
    // 直推奖励
    try {
      const res = await axios.get(`https://laychat.aitechprod.xyz/api/index/reward_grant_log?address=${address}&page=1&pagesize=99999&type=2`);
      if (res.data.code === 1) {
        setDataListzhituiliangji(res.data.data.data)
      }
      // setResponse(res.data);
    } catch (error) {
      console.error('请求失败:', error);
    }
  }
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setIsModalOpen1(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setIsModalOpen1(false);
  };
  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    window.sessionStorage.setItem("lang", lang)
    setLangType(lang)
  }
  const goComingSoon = () => {
    message.warn("Coming Soon")
  }
  const goOpen = (url) => {
    window.open(url)
  }
  const onCopy = () => {
    message.success(t("Copy Success"))
  }
  const tapBuild = () => {
    if (!address) {
      return
    }
    if (inviter.toLowerCase() === address.toLowerCase()) {
      return
    }
    setLoadingInvite(true);
    writeContract({
      address: RWA_CONTRACT_ADDRESS,
      abi: RWAABI,
      functionName: "binding",
      chainId: chainIdOwn,
      args: [inviter]
    })
  }
  const onChange = ({ target: { value } }) => {
    setInviter(value)
  }
  const tapReceiveUsdc = () => {
    if (Number(homeView?.rewardsDirect) > 0) {
      setLoading1(true)
      writeContract({
        address: RWA_CONTRACT_ADDRESS,
        abi: RWAABI,
        functionName: "claimDirect",
        chainId: chainIdOwn,
      })
    }

  }
  const tapReceive = () => {

    if (Number(rwaInfo[0]) > Number(homeView?.earned)) {
      return
    }
    if (!isSignMessage) {
      return
    }
    setLoading(true)
    writeContract({
      address: RWA_CONTRACT_ADDRESS,
      abi: RWAABI,
      functionName: "claim",
      chainId: chainIdOwn,
      value: rwaInfo[1],
    })
  }
  const saveNumberTwo = (num) => {
    if (num * 1 === 0) return 0;
    let arr = (num + "").split(".");
    if (arr.length === 2) {
      let new_num = arr[0] + "." + arr[1].substring(0, 2);
      return new_num === "0.00" ? "0" : new_num;
    } else {
      return num + ".00";
    }
  }
  const saveNumberSix = (num) => {
    if (num * 1 === 0) return 0;
    let arr = (num + "").split(".");
    if (arr.length === 2) {
      let new_num = arr[0] + "." + arr[1].substring(0, 6);
      return new_num === "0.00" ? "0" : new_num;
    } else {
      return num + ".00";
    }
  }
  const against = (t) => {
    if (!t) return "";
    return t.substring(0, 3) + "****" + t.substring(t.length - 4, t.length);
  };
  const signMessageHandle = async () => {
    console.log(1)
    signMessage({ message: 'DEAI Approve' })
  }
  return (
    <div className="mine_rwa_box">
      <div className="tab_box">
        <div className="menu menu1" onClick={() => navigate("/rwa")}>RWA</div>
        <div className="menu active">{t("mine")}</div>
      </div>
      <div className="con_box">
        <div className="top_box">
          <div className="left_box">
            <div className="boxbox">
              <div className="item2 kuang5">
                <img className="line" src={line1} alt="" />
                <img className="xingxing" src={xingxing} alt="" />
                <div className="tit">{t("Team data")}</div>
                <div className="flex2">
                  <div className="flex2_box">
                    <div className="num">{isSignMessage ? Number(homeView?.juniorNum) : 0}</div>
                    <div className="text">{t("Number of direct referrals")}</div>
                  </div>
                  <div className="flex2_box">
                    <div className="num">{isSignMessage ? ((address && address.toLocaleLowerCase() === "0x76F47e99A66724A699C0366858Ce59Db763eaabd".toLocaleLowerCase()) ? Number(homeView?.teamNum) + 23 : Number(homeView?.teamNum)) : 0}</div>
                    <div className="text">{t("Team size")}</div>
                  </div>
                </div>
                <div className="flex2">
                  <div className="flex2_box">
                    <div className="num">{isSignMessage ? saveNumberTwo(formatEther(homeView?.stakeTeam || "0")) : 0}</div>
                    <div className="text">{t("Team performance")}</div>
                  </div>
                  <div className="flex2_box">
                    <div className="num">{isSignMessage ? saveNumberTwo(formatEther(homeView?.seniorTotal || "0")) : 0}</div>
                    <div className="text">{t("Region")}</div>
                  </div>
                  <div className="flex2_box">
                    <div className="num">{isSignMessage ? saveNumberTwo(formatEther(homeView?.stakeTeamOther || "0")) : 0}</div>
                    <div className="text">{t("the remaining")}</div>
                  </div>
                </div>
              </div>

              <div className="item2 kuang6">
                <img className="line2" src={line2} alt="" />
                <img className="fangkuai" src={fangkuai} alt="" />
                {/* <div className="tit">
                  <div>{t("Directly push USDC income")} </div>
                  <div className="history" onClick={() => setIsModalOpen1(true)}>{t("Unlock History")}</div>
                </div>

                <div className="bot_box">
                  <div className="flex2_box">
                    <div className="num">{isSignMessage ? saveNumberTwo(remainingAmount) : 0} USDC</div>
                    <div className="text">{t("To be unlocked")}</div>
                  </div>
                  <div className="flex2_box">
                    <div className="num">{isSignMessage ? saveNumberTwo(transferAmount) : 0} USDC</div>
                    <div className="text">{t("Unlocked")}</div>
                  </div>
                </div> */}
                <div className="tit">{t("Directly push USDC income")}</div>
                <div className="bot_box flex_text">
                  {t("Data update in progress")}
                </div>
              </div>
            </div>


            <div className="item">
              <div className="tit">
                <div >{t("My Investment")}</div>
              </div>
              <div className="box1">
                <div className="left_box3">
                  <div className="left_box1">
                    <div>
                      <div className="num">{isSignMessage ? saveNumberSix(formatEther(homeView?.canClaimUsdc || "0")) : 0}</div>
                      <div className="text">{t("Waiting for collection (usdc)")}</div>
                    </div>
                    <div>
                      <div className="num">{isSignMessage ? saveNumberSix(formatEther(homeView?.earned || "0")) : 0}</div>
                      <div className="text">{t("Waiting for collection (deai)")}</div>
                      <Button className={Number(rwaInfo?.[0]) > Number(homeView?.earned) ? "btn btn1" : "btn"} type="primary" size="small" loading={loading} onClick={tapReceive}>{t("receive")}</Button>
                    </div>
                  </div>
                  <div className="left_box1">
                    <div className="item1">
                      <div>
                        <div className="num">{isSignMessage ? formatEther(homeView?.steak || "0") : 0}</div>
                        <div className="text">{t("Total Investment")}</div>
                      </div>
                      <div className="mt32">
                        <div className="num">{isSignMessage ? saveNumberTwo(formatEther(homeView?.earnedUsdc || "0")) : 0}</div>
                        <div className="text">{t("Released(USDC)")}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="right_box2">

                  <div className="item1">
                    <div>
                      <div className="num1">{t("(Daily chemical 0.7-1.2%)")}</div>
                      <div className="text1">{t("income")}</div>
                    </div>
                    <div className="mt32 flex5">
                      <div>
                        <div className="num">{isSignMessage ? saveNumberTwo(formatEther(remainingData || "0")) : 0}</div>
                        <div className="text">{t("Residual income (USDC)")}</div>
                      </div>
                      {/* <div>
                        <div className="num">{isSignMessage ? saveNumberTwo(formatEther(homeView?.payedRewards || "0")) : 0}</div>
                        <div className="text">{t("Already received (deai)")}</div>
                      </div> */}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="right_box">
            <img className="xing2" src={xing2} alt="" />
            <div className="item">
              <div className="tit">
                <div >{t("Current level")}</div>
                <div className="deatils" onClick={() => setIsModalOpen(true)}>{t("Rules")}</div>
              </div>
              <div className="box">
                <img className="img" src={vip} alt="" />
                <div className="text">{isSignMessage ? (Number(homeView?.level) === 1 ?  t("member") : Number(homeView?.level) === 2 ?  t("Operators") : Number(homeView?.level) === 3 ?  t("Operations Center") : Number(homeView?.level) === 4 ?  t("Partner") :  t("Genesis Partner")) :  t("member")}</div>

              </div>
            </div>
          </div>
        </div>
        <div className="flex_box3">
          <div className="item2 m_block">
            <img className="bg4" src={bg4} alt="" />
            <div className="flex_invite">
              <div className="tit">{t("My inviter")}</div>
              <div className="input_box">
                <Input className="input" value={inviter} onChange={onChange} readOnly={homeView?.higherLevel != "0x0000000000000000000000000000000000000000"} placeholder={t("Please enter the inviter's address")} />
                <Button type="primary" className={homeView?.higherLevel != "0x0000000000000000000000000000000000000000" ? "btn btn1" : "btn"} onClick={tapBuild} loading={loadingInvite}>{homeView?.higherLevel != "0x0000000000000000000000000000000000000000" ? t("Binded") : t("Binding")}</Button>
              </div>
              <div className="tit">{t("My invitation link")}</div>
              <div className="input_box">
                <Input className="input" value={inviterAddress} readOnly placeholder={t("No invitation qualification")} />
                {
                  Number(homeView?.steak) > 0 ?
                    <CopyToClipboard text={inviterAddress}
                      onCopy={onCopy}>
                      <Button type="primary" className="btn">{t("copy")}</Button>
                    </CopyToClipboard>
                    : null
                }
              </div>
            </div>
          </div>
          <div className="data_box">
            <img className="duojiantou" src={duojiantou} alt="" />
            <div className="tit">
              <div className={tabIndex === 1 ? "item active" : "item"} onClick={() => setTabIndex(1)}>{t("Release Details")}</div>
              <div className={tabIndex === 2 ? "item active" : "item"} onClick={() => setTabIndex(2)}>{t("Direct referral details")}</div>
              <div className={tabIndex === 3 ? "item active" : "item"} onClick={() => setTabIndex(3)}>{t("Performance Details")}</div>
              <div className={tabIndex === 4 ? "item active" : "item"} onClick={() => setTabIndex(4)}>{t("Investment Details")}</div>
              <div className={tabIndex === 5 ? "item active" : "item"} onClick={() => setTabIndex(5)}>{t("Claim Details")}</div>
            </div>
            <div className="list" style={{ display: tabIndex === 1 && isSignMessage ? "block" : "none" }}>
              {
                dataListshifang.map(item => {
                  return (
                    <div className="item" key={item.id}>
                      <div className="td1">{item.type === 1 ? t("fixed release") : t("accelerated release")}</div>
                      <div className="td2">{saveNumberTwo(item.amount ? formatEther(item.amount) : 0)} USDC</div>
                      <div className="td3">{dayjs(item.created_at * 1000).format("YYYY-MM-DD HH:mm:ss")}</div>
                    </div>
                  )
                })
              }
            </div>
            <div className="list" style={{ display: tabIndex === 2 && isSignMessage ? "block" : "none" }}>
              {
                dataListzhitui.map(item => {
                  return (
                    <div className="item" key={item.id}>
                      <div className="td1">{against(item.address)}</div>
                      <div className="td3">{dayjs(item.created_at * 1000).format("YYYY-MM-DD HH:mm:ss")}</div>
                    </div>
                  )
                })
              }
            </div>
            <div className="list" style={{ display: tabIndex === 3 && isSignMessage ? "block" : "none" }}>
              {
                dataListyeji.map(item => {
                  return (
                    <div className="item" key={item.id}>
                      <div className="td1">{against(item.address)}</div>
                      <div className="td2">{saveNumberTwo(item.amount ? formatEther(item.amount) : 0)} USDC</div>
                      <div className="td3">{dayjs(item.created_at * 1000).format("YYYY-MM-DD HH:mm:ss")}</div>
                    </div>
                  )
                })
              }
            </div>
            <div className="list" style={{ display: tabIndex === 4 && isSignMessage ? "block" : "none" }}>
              {
                dataListtouzi.map(item => {
                  return (
                    <div className="item" key={item.id}>
                      <div className="td1">{against(item.address)}</div>
                      <div className="td2">{saveNumberTwo(item.stake_amount ? formatEther(item.stake_amount) : 0)} USDC</div>
                      <div className="td3">{dayjs(item.created_at * 1000).format("YYYY-MM-DD HH:mm:ss")}</div>
                    </div>
                  )
                })
              }
            </div>
            <div className="list" style={{ display: tabIndex === 5 && isSignMessage ? "block" : "none" }}>
              {
                dataListlingqu.map(item => {
                  return (
                    <div className="item" key={item.id}>
                      {/* <div className="td1">{against(item.address)}</div> */}
                      <div className="td4">{saveNumberTwo(item.deai)} DEAI + {saveNumberTwo(item.usdc)} USDC</div>
                      <div className="td4">{dayjs(item.created_at * 1000).format("YYYY-MM-DD HH:mm:ss")}</div>
                    </div>
                  )
                })
              }
            </div>
            <div className="nodata" style={{ display: (tabIndex === 1 && dataListshifang.length === 0 || !isSignMessage) || (tabIndex === 2 && dataListzhitui.length === 0 || !isSignMessage) || (tabIndex === 3 && dataListyeji.length === 0 || !isSignMessage) || (tabIndex === 4 && dataListtouzi.length === 0 || !isSignMessage) || (tabIndex === 5 && dataListlingqu.length === 0 || !isSignMessage) ? "flex" : "none" }}><img src={nodata} alt="" /></div>
          </div>
          <div className="item2 m_hide">
            <img className="bg4" src={bg4} alt="" />
            <div className="flex_invite">
              <div className="tit">{t("My inviter")}</div>
              <div className="input_box">
                <Input className="input" value={inviter} onChange={onChange} readOnly={homeView?.higherLevel != "0x0000000000000000000000000000000000000000"} placeholder={t("Please enter the inviter's address")} />
                <Button type="primary" className={homeView?.higherLevel != "0x0000000000000000000000000000000000000000" ? "btn btn1" : "btn"} onClick={tapBuild} loading={loadingInvite}>{homeView?.higherLevel != "0x0000000000000000000000000000000000000000" ? t("Binded") : t("Binding")}</Button>
              </div>
              <div className="tit">{t("My invitation link")}</div>
              <div className="input_box">
                <Input className="input" value={inviterAddress} readOnly placeholder={t("No invitation qualification")} />
                {
                  Number(homeView?.steak) > 0 ?
                    <CopyToClipboard text={inviterAddress}
                      onCopy={onCopy}>
                      <Button type="primary" className="btn">{t("copy")}</Button>
                    </CopyToClipboard>
                    : null
                }
              </div>
            </div>
          </div>
        </div>


      </div>
      <Modal title="" centered open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
        <div class="rule_box">
          <div>{t("1. Ecological Strategic Layout")}</div>
          <div>{t("1. RWA asset tokenization innovation")}</div>
          <div>{t("DEAI DAO utilizes advanced blockchain technology to efficiently and transparently tokenize Real World Assets (RWA), reshaping the traditional asset circulation model. This innovation not only significantly improves the liquidity and tradability of assets, but also provides a compliant and low threshold high-quality asset allocation channel for global investors. ")}</div>
          <div>{t("2. RWA+AI intelligent computing center leasing integrated ecosystem")}</div>
          <div>{t("DEAI DAO has innovatively integrated RWA business with the AI computing power leasing market, building a new business model that combines decentralized finance (DeFi) with physical industries. By holding RWA tokenized assets, investors can indirectly participate in the high growth AI computing power leasing market and enjoy the sustained returns brought by computing power business. All income distributions are automatically executed through smart contracts, ensuring transparency, efficiency, and trustworthiness, thus creating a sustainable economic ecosystem that benefits all parties. ")}</div>
          <div>{t("II. RWA Asset Pricing and Anchoring Mechanism")}</div>
          <div>{t("RWA Standard Card Pricing: 100 USDC per card")}</div>
          <div>{t("Bottom asset anchoring: AI intelligent computing center leasing business")}</div>
          <div>{t("The value of RWA assets is supported by stable returns from AI computing leasing business, ensuring that the assets have real and sustainable cash flow returns. ")}</div>
          <div>{t("III. Participant Benefit Model")}</div>
          <div>{t("Investors participate in the DEAI ecosystem in USDC and enjoy the considerable returns brought by AI computing power leasing business. ")}</div>
          <div>{t("Core revenue mechanism:")}</div>
          <div>{t("Investment cycle: 200 days")}</div>
          <div>{t("Expected daily yield: 0.7% -1.2%")}</div>
          <div>{t("Profit settlement method: Real time settlement with DEAI token price")}</div>
          <div>{t("Example of Profit:")}</div>
          <div>{t("Investment amount: 30 RWA cards (3000 USDC)")}</div>
          <div>{t("200 day total return: approximately 6000 USDC")}</div>
          <div>{t("Daily average return: approximately 30 USDC (settled at DEAI real-time price)")}</div>
          <div>{t("tip3")}</div>
          <div>{t("tip4")}</div>
          <div>{t("tip5")}</div>
          <div>{t("tip6")}</div>
          <div>{t("tip7")}</div>
          <div>{t("tip8")}</div>
          <div>{t("DEAI tokens can freely circulate on mainstream decentralized exchanges such as Uniswap, ensuring efficient monetization of profits.")}</div>
          <div>{t("IV. Future Prospects")}</div>
          <div>{t("DEAI DAO will continue to optimize the integrated ecosystem of RWA and AI computing power leasing, promote the deep integration of decentralized finance and the real economy, and provide global investors with more efficient, transparent, and robust asset appreciation solutions. ")}</div>
          <div>Join DEAI DAO — Where Real-World Assets Meet Decentralized AI Computing.</div>
        </div>
      </Modal>
      <Modal title={""} centered open={isModalOpen1} onOk={handleOk} onCancel={handleCancel} footer={null}>
        <div class="details_box">
          <div className="tit">{t("Unlock History")}</div>
          {
            dataListzhituijiangli.map(item => {
              return (
                <div className="item" key={item.id}>
                  <div className="time">{dayjs(item.created_at * 1000).format("YYYY-MM-DD HH:mm:ss")}</div>
                  <div className="amount">{saveNumberTwo(item.amount)} USDC</div>
                  <div className="amount">{item.is_grant === 1 ? t("Transferred funds") : t("Pending transfer")}</div>
                </div>
              )
            })
          }
        </div>
      </Modal>
    </div >
  );
};
export default Mine;
